import AxiosProvider from '@/app/utils/api/axios-provider';
import { AxiosResponse } from 'axios';
import { Datasource } from '@/app/shared/types/datasource.interface';

export default {
  getDataSources(): Promise<AxiosResponse<{ data: Datasource[] }>> {
    return AxiosProvider.adminApiClient.get('/datasources');
  },
};
